import $ from 'jquery';
import debounce from 'lodash/debounce';
import bind from 'lodash/bind';
import get from 'lodash/get';
import './MemberResignForm.scss';
import template from './MemberResignForm.vhtml';

export default {
	name: 'MemberResignForm',
	template: template,
	props: {
		reasons: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		isSubmitting: false,
		submitStatus: '',
		result: {},
		signupData: null,
		honey: '',
		hasTimeout: false,
		isFetching: false,
		showMessage: false,
		selectedReason: "",
	}),
	computed: {
		cvr: vm => get(vm, 'signupData.cvr', ''),
		company: vm => get(vm, 'signupData.company', ''),
		reasonOptions() {
			return JSON.parse(this.reasons);
		},
		resignReason: {
			get() {
				return this.selectedReason;
			},
			set(newValue) {
				this.selectedReason = newValue
				this.signupData.reason = newValue.reason_option
				this.signupData.reasonId = newValue.reason_option_crmid
			}
		}
	},
	watch: {
		cvr() {
			this.showMessage = false
			if (this.cvr === '') {
				this.$options.autoComplete.cancel();
			} else if (/^[0-9]{8}$/.test(this.cvr)) {
				const param = {
					cvr: this.cvr,
				};
				this.autoComplete(param);
			}
		}
	},
	methods: {
		spaceToNbsp(str) {
			return str.replace(' ', '&nbsp;');
		},
		setupPlaceholder(str) {
			return `${str}...`;
		},
		resetStatus() {
			this.submitStatus = '';
		},
		setupSignupData() {
			return {
				company: '',
				name: '',
				cvr: '',
				phone: '',
				email: '',
				reason: '',
				comment: '',
			};
		},
		validateBeforeSubmit() {
			this.$validator.validateAll().then(() => {
				if (this.errors.items.length === 0) {
					this.submit(this.signupData);
				} else {
					this.$scrollTo(this.$refs[this.errors.items[0].field]);
				}
			});
		},
		submit(data) {
			if (this.honey === '') {
				this.isSubmitting = true;
				this.$emit('member-signup-submitting', true);
				$.post('/wp-json/be/v1/member-resign', JSON.stringify(data))
					.then(result => {
						if (typeof result != 'object') {
							result = JSON.parse(result)
						}
						this.submitStatus = result.status;
						this.$emit('member-signup-status', this.submitStatus);
						this.$validator.reset();
						this.signupData = this.setupSignupData();

						// if (this.submitStatus === 'success') {
						// 	trackMemberSignup();
						// }
					})
					.catch(() => {
						this.submitStatus = 'error';
						this.$emit('member-signup-status', this.submitStatus);
					})
					.always((this.isSubmitting = false));
			}
		},
		autoComplete(param) {
			if (!this.hasTimeout) {
				this.$options.autoComplete(param);
			}
		},
		resetComment(value) {
			if (value !== 'other') {
				this.signupData.comment = '';
			}
		},
	},
	created() {
		this.signupData = this.setupSignupData();
		this.$options.autoComplete = debounce(bind(autoComplete, this), 1000);
	},
};

function autoComplete(param) {
	const endpoint = '/wp-json/be/v1/cvr-lookup/';
	this.showMessage = false
	this.isFetching = true;
	getRequest(endpoint, param)
		.then(result => {
			if (typeof result != 'object') {
				result = JSON.parse(result)
			}

			if (result.message === 'One hit') {
				this.hasTimeout = true;

				const cvr = get(result, 'data.cvr', null);
				if (get(this, 'signupData.cvr', null) !== null && cvr !== null) {
					if (cvr == false) {
						this.signupData.cvr = null;
					}
					else {
						this.signupData.cvr = cvr;
					}
				}

				const company = get(result, 'data.company', null);
				if (get(this, 'signupData.company', null) !== null && company !== null) {
					if (company == false) {
						this.signupData.company = null;
					}
					else {
						this.signupData.company = company;
					}
				}

				const email = get(result, 'data.email', null);
				if (get(this, 'signupData.email', null) !== null && email !== null) {
					if (email == false) {
						this.signupData.email = null;
					}
					else {
						this.signupData.email = email;
					}
				}

				const phone = get(result, 'data.phone', null);
				if (get(this, 'signupData.phone', null) !== null && phone !== null) {
					if (phone == false) {
						this.signupData.phone = null;
					}
					else {
						this.signupData.phone = phone;
					}
				}

				this.$nextTick(() => {
					this.hasTimeout = false;
				});

				this.responseMessage = 'Data hentet med success fra CVR.dk'
				this.messageClass = 'o-input__success'
			} else {
				this.responseMessage = 'CVR nr. blev ikke fundet hos CVR.dk'
				this.messageClass = 'o-input__error'
			}
		})
		.always(() => {
			this.isFetching = false
			this.$nextTick(() => {
				this.showMessage = true
			});

		});
}

/**
 * Make request to WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getRequest(endpoint, params) {
	return $.get(endpoint, params);
}
